import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RequestMethod, RestService} from '../../../shared/services/rest.service';
import {ApiEndpoints} from '../../../shared/constants/ApiEndpoints';

@Component({
  selector: 'app-quickbooks-authentication',
  templateUrl: './quickbooks-authentication.component.html',
  styleUrls: ['./quickbooks-authentication.component.scss']
})
export class QuickbooksAuthenticationComponent implements OnInit {

  urlParams: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private restService: RestService,
    private router: Router
  ) {
    this.urlParams = activatedRoute.snapshot.queryParams;

  }

  ngOnInit() {
    this.connectToQbo();
  }

  connectToQbo() {
    this.restService.publicRequest<any>(RequestMethod.GET, '/p1/' + ApiEndpoints.ACCOUNT.QBO, `callback?code=` + this.urlParams.code + '&state=' + this.urlParams.state + '&realmId=' + this.urlParams.realmId).subscribe(
      result => {
        this.router.navigate(['/account-settings/users']).then(() => {
          window.location.reload();
        });
      }
    );
  }
}
